<template>
    <v-container fluid>
                <CardsInHopperCount
                    v-for="i in Array.from(Array(hoppersCount), (e,i)=> i + 1)"
                    :key="i"
                    :hopper-number="i"
                    :device="device"
                    :products="products"
                    v-on:changed="(items) => $emit('changed', i, items)"
                />
    </v-container>
</template>

<script>
import CardsInHopperCount from '@/components/Kiosks/CardsInHopperCount';

export default {
  name: 'ManageDeviceCardsList',
  props: {
    device: {
      type: Object,
      required: true
    },
    hoppersCount: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      products: [],
      hoppers:[],
      selectedProducts: Array.from(Array(this.hoppersCount), () => [])
    };
  },
  mounted() {
    this.setHoppers();
  },
  methods: {
    setHoppers(){
      this.hoppers = [];
      for(var i = 0; i < this.device.hoppersCount; i++)
        this.hoppers.push(i);
    }
  },
  components: {CardsInHopperCount},
};
</script>
